
import { BlocklyHelperService } from "../blockly-helper.service";
import { BLOCKLY_COLORS, BlocklyToolboxCategory } from "../blocky-types.types";

export function BlocklyCategory_VIEW_CHAT(name: string = "unnamed", BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.BOTVIEW, name: name, contents: [] };
  cat.contents = [
    BH.label("Bot-Ansichten -> " + name),

    BH.withNested(
      BH.styling("AVATAR_BOT_SET", "Setze Avatar für Bot {{ pic[@check=IMAGE] }}", "await RAGAI.CHAT_AVATAR.setBotImg({{pic}});"),
      [{ forValue: "pic", isShadow: true, targetBlockType: 'BLOCK_STACK_IMAGE' }]
    ),
    BH.withNested(
      BH.styling("AVATAR_USER_SET", "Setze Avatar für Nutzer {{ pic[@check=IMAGE] }}", "await RAGAI.CHAT_AVATAR.setUserImg({{pic}});"),
      [{ forValue: "pic", isShadow: true, targetBlockType: 'BLOCK_STACK_IMAGE' }]
    ),
    BH.styling("AVATAR_CHAT_UNSET", "Entferne Avatar für {{who:dropdown=Nutzer|User,Bot|Bot}}", "await RAGAI.CHAT_AVATAR.unset{{who}}Img();"),
    BH.styling("AVATAR_CHAT_FOOTER", "Footer {{option:dropdown=anzeigen|show,ausblenden|hide}}", "await RAGAI.DOM.{{option}}Footer();"),
    BH.styling("AVATAR_CHAT_Header", "Header {{option:dropdown=anzeigen|show,ausblenden|hide}}", "await RAGAI.DOM.{{option}}Header();")
  ];
  return cat;

}
